import { BaseRequest } from '@trukt/types/BaseRequest';
import { AxiosPromise } from 'axios';
import { BaseApi } from './BaseApi';

export type TrimbleMapsSingleSearchRequest = Pick<
  BaseRequest<{
    query: string;
    maxResults?: number;
    currentLonLat?: number;
    excludeResultsFor?: string;
    includeOnly?: string;
    poiCategories?: string;
    countries?: string;
    countryType?: string;
    states?: string;
    include?: string;
    useCustomPlaces?: boolean;
    separateHN?: boolean;
    getAllHNRanges?: boolean;
    includeTrimblePlaceIds?: boolean;
    lang?: string;
    matchNamedRoadsOnly?: boolean;
    maxCleanupMiles?: number;
    heading?: number;
  }>,
  'queryParams'
>;

interface TrimbleMapsSingleSearchAddress {
  StreetAddress: string;
  City: string;
  State: string;
  StateName: string;
  Zip: string;
  County: string;
  Country: string;
  CountryFullName: string;
  SPLC?: any;
}

interface TrimbleMapsSingleSearchCoords {
  Lat: string;
  Lon: string;
}

export interface TrimbleMapsSingleSearchLocation {
  Address: TrimbleMapsSingleSearchAddress;
  Coords: TrimbleMapsSingleSearchCoords;
  Region: number;
  POITypeID: number;
  PersistentPOIID: number;
  SiteID: number;
  ResultType: number;
  ShortString: string;
  TimeZone: string;
}

export type TrimbleMapsSingleSearchResponse = {
  Err: number;
  Locations: TrimbleMapsSingleSearchLocation[];
};

export const trimbleMapsSingleSearchApiBaseUrl = 'https://singlesearch.alk.com/na/api';

export enum TRIMBLE_MAPS_SINGLE_SEARCH_RESULT_TYPE_MAP {
  COUNTRY = 0,
  STATE = 1,
  CITY = 3,
  ZIP = 4,
  STREET = 6,
}

export class TrimbleMapsSingleSearchApi extends BaseApi {
  constructor(apiKey: string) {
    super({
      baseURL: trimbleMapsSingleSearchApiBaseUrl,
      params: {
        authToken: apiKey,
      },
    });
  }

  search(request: TrimbleMapsSingleSearchRequest): AxiosPromise<TrimbleMapsSingleSearchResponse> {
    if (!request.queryParams.countries) {
      request.queryParams.countries = 'US, CA';
    }

    if (!request.queryParams.poiCategories) {
      request.queryParams.poiCategories = 'Travel & Transportation,Truck Stop';
    }

    return this.instance.get('/search', { params: request.queryParams });
  }
}
